<template>
    <or-modal
        ref="confirmationPhraseModal"
        dismiss-on="close-button"
        class="confirmation-phrase--modal"
        :title="modalTitle"
        @close="closeConfirmationPhrase"
    >
        <or-textbox
            class="confirmation-phrase--textarea"
            placeholder=""
            v-model="localConfirmationPhrase"
            show-error-text="persistently"
            multi-line
            :error="confirmationPhraseError"
            :invalid="!!confirmationPhraseError"
        />

        <div slot="footer" class="confirmation-phrase--actions">
            <div>
                <or-button
                    type='secondary'
                    v-if="!newPhrase"
                    @click="deleteConfirmationPhrase"
                    color='red'
                    :loading="$props.updating"
                >
                  {{ $t('generic.delete') }}
                </or-button>
            </div>
            <div>
                <or-button
                    type='secondary'
                    @click="closeConfirmationPhrase"
                    :loading="$props.updating"
                >
                  {{ $t('generic.cancel') }}
                </or-button>
                <or-button
                    color="primary"
                    @click="saveConfirmationPhrase"
                    :loading="$props.updating"
                >
                  {{ $t(newPhrase ? 'generic.add' : 'generic.save') }}
                </or-button>
            </div>
        </div>
    </or-modal>
</template>

<script>
import { confirmationPhraseValidation } from '@/mixins/confirmation-phrase-validation.mixin'

export default {
  mixins: [confirmationPhraseValidation],
  props: {
    newPhrase: Boolean,
    confirmationPhrase: [String, null, undefined],
    opened: Boolean,
    updating: Boolean
  },

  data () {
    return {
      localConfirmationPhrase: this.$props.confirmationPhrase || ''
    }
  },

  computed: {
    modalTitle () {
      return `${this.$props.newPhrase ? 'Add' : 'Edit'} Confirmation phrase`
    }
  },

  methods: {
    saveConfirmationPhrase () {
      this.$v.localConfirmationPhrase.$touch()
      if (this.$v.localConfirmationPhrase.$invalid) {
        return
      }
      this.$emit('save', this.localConfirmationPhrase)
    },

    closeConfirmationPhrase () {
      this.$emit('close')
      this.$v.localConfirmationPhrase.$reset()
      this.localConfirmationPhrase = this.$props.confirmationPhrase || ''
    },

    deleteConfirmationPhrase () {
      this.$v.localConfirmationPhrase.$reset()
      this.$emit('delete')
    }
  },

  watch: {
    confirmationPhrase (newValue) {
      this.localConfirmationPhrase = newValue || ''
    },

    opened (isOpened) {
      if (isOpened) {
        this.$refs.confirmationPhraseModal.open()
      } else {
        this.$refs.confirmationPhraseModal.close()
      }
    }
  }
}

</script>

<style lang="scss" scoped>
    .confirmation-phrase--textarea {
        margin-bottom: 0;
    }

    .confirmation-phrase--actions {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .confirmation-phrase--modal {
        width: 100%;
        ::v-deep .ui-textbox__wr-input-feedback {
            .ui-textbox__textarea {
                height: 312px !important;
            }
        }
        ::v-deep .ui-modal__footer {
            border-top: none !important;
        }
    }
</style>
